import { render, staticRenderFns } from "./ApeironUsersUpdate.vue?vue&type=template&id=0d2a28d4"
import script from "./ApeironUsersUpdate.vue?vue&type=script&lang=js"
export * from "./ApeironUsersUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports